import { render, staticRenderFns } from "./linkManagementList.vue?vue&type=template&id=40bd08b8&scoped=true&"
import script from "./linkManagementList.vue?vue&type=script&lang=js&"
export * from "./linkManagementList.vue?vue&type=script&lang=js&"
import style0 from "./linkManagementList.vue?vue&type=style&index=0&id=40bd08b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bd08b8",
  null
  
)

export default component.exports